import { render } from "./SetDiscountGratuityModal.vue?vue&type=template&id=425afe80&scoped=true"
import script from "./SetDiscountGratuityModal.vue?vue&type=script&lang=js"
export * from "./SetDiscountGratuityModal.vue?vue&type=script&lang=js"

import "./SetDiscountGratuityModal.vue?vue&type=style&index=0&id=425afe80&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-425afe80"]])

export default __exports__